import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  startOfDay,
  startOfMonth,
  startOfWeek,
  subDays,
  subMonths,
  subWeeks,
} from 'date-fns';
import { ptBR } from 'date-fns/locale';

export type DateRange = {
  startDate: Date;
  endDate: Date;
};

export type DateRangePreset = {
  id: string;
  label: string;
  getRange: () => DateRange;
};

const WEEK_OPTIONS = { weekStartsOn: 1 as const, locale: ptBR };

export const getTodayRange = (date: Date = new Date()): DateRange => ({
  startDate: startOfDay(date),
  endDate: endOfDay(date),
});

export const getYesterdayRange = (date: Date = new Date()): DateRange => {
  const yesterday = subDays(date, 1);

  return {
    startDate: startOfDay(yesterday),
    endDate: endOfDay(yesterday),
  };
};

export const getThisWeekRange = (date: Date = new Date()): DateRange => ({
  startDate: startOfWeek(date, WEEK_OPTIONS),
  endDate: endOfWeek(date, WEEK_OPTIONS),
});

export const getLastWeekRange = (date: Date = new Date()): DateRange => {
  const lastWeek = subWeeks(date, 1);

  return {
    startDate: startOfWeek(lastWeek, WEEK_OPTIONS),
    endDate: endOfWeek(lastWeek, WEEK_OPTIONS),
  };
};

export const getThisMonthRange = (date: Date = new Date()): DateRange => ({
  startDate: startOfMonth(date),
  endDate: endOfMonth(date),
});

export const getLastMonthRange = (date: Date = new Date()): DateRange => {
  const lastMonth = subMonths(date, 1);

  return {
    startDate: startOfMonth(lastMonth),
    endDate: endOfMonth(lastMonth),
  };
};

export const RANGE_PRESETS: DateRangePreset[] = [
  {
    id: 'today',
    label: 'Hoje',
    getRange: () => getTodayRange(),
  },
  {
    id: 'yesterday',
    label: 'Ontem',
    getRange: () => getYesterdayRange(),
  },
  {
    id: 'this-week',
    label: 'Esta semana',
    getRange: () => getThisWeekRange(),
  },
  {
    id: 'last-week',
    label: 'Semana passada',
    getRange: () => getLastWeekRange(),
  },
  {
    id: 'this-month',
    label: 'Este mês',
    getRange: () => getThisMonthRange(),
  },
  {
    id: 'last-month',
    label: 'Mês passado',
    getRange: () => getLastMonthRange(),
  },
];
